const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim(),
    { assign, isUndefined } = require('lodash');

module.exports = ($stateProvider) => {
    const adobeParam = { cmpid: 'smaf014' };

    $stateProvider
        .state('shop.productdetails', {
            // temporary for old product description popup
            url: '/productdetails/{productId}/{productName}?{googleshop:bool}&{store_code:string}&{cmpid:string}&{reviewPageNumber:int}&{reviewSortBy}&{gclid}&{cvosrc}&{cvo_crid}&{cvo_campaign}',
            params: {
                product: null,
            },
            data: {
                pageMetadata: [
                    'DetailProductService', 'PageMetadataService', '$stateParams', 'Settings', 'StoreService',
                    function (detailProductService, pageMetadataService, $stateParams, settings, storeService) {
                        let storeCode;
                        if ($stateParams.googleshop) {
                            storeCode = storeService.getStoreCode($stateParams);
                        }
                        return detailProductService.getProductDetail($stateParams.productId, null, null, null, settings.content.productDetailStoreInfo ? storeCode : null).then(details => pageMetadataService.getMetadata({
                            name: `${details.Product.Name} ${details.Product.PackageSize}`.trim(),
                        }, null, null, 'Product'));
                    },
                ],
            },
            onEnter: ['$state', '$window', '$timeout', '$stateParams', 'Settings', 'RichRelevanceService', 'ShopperService', 'FulfilmentService', 'StoreService', '$rootScope', '$location',
                function ($state, $window, $timeout, $stateParams, settings, richRelevanceService, shopperService, fulfilmentService, storeService, $rootScope, $location) {
                    if (settings.content.productDetailStoreInfo) {
                        if ($stateParams.googleshop) {


                            $rootScope.merchantHostedLocation = $location.path();

                            $rootScope.$watch(() => $location.path(), (newLocation) => {
                                // when using browser back button from store locator, productDetails route is not triggered,
                                // so selected store is not updated. This code is triggered instead on browser back to compensate for this.
                                if ($rootScope.merchantHostedLocation === newLocation) {
                                    const storeCode = storeService.getStoreCode($stateParams);

                                    storeService.getStore(storeCode, 'SUPERMARKETS')
                                        .then((store) => {
                                            storeService.setSelectedStore(store);
                                        });

                                }
                            });
                            /**
                             * Change store location
                             * if store code parameter is supplied, set store to the provided store code
                             * else use the default store code from the setting.
                             */
                            const storeCode = storeService.getStoreCode($stateParams);

                            storeService.getStore(storeCode, 'SUPERMARKETS')
                                .then((store) => {
                                    storeService.setSelectedStore(store);
                                });

                            if (!$stateParams.cmpid) {
                                $timeout(() => $state.go($state.current, assign($stateParams, adobeParam), { location: 'replace' }));
                            }
                        } else {
                            storeService.setSelectedStore(null);
                        }
                    }

                    if ($stateParams.product) {
                        richRelevanceService.rrItemDetailsPageRequest($stateParams.product.Stockcode, $stateParams.product.Source);
                    }
                },
            ],
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('productdetail');
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.productdetails': {
                    controller: ['DetailProductService', 'StoreService', '$stateParams', 'Settings', function (detailProductService, storeService, $stateParams, settings) {
                        if ($stateParams.product) {
                            this.detail = { Product: $stateParams.product };
                        }
                        let storeCode;
                        if ($stateParams.googleshop) {
                            storeCode = storeService.getStoreCode($stateParams);
                        }

                        detailProductService.getProductDetail($stateParams.productId, null, null, null, settings.content.productDetailStoreInfo ? storeCode : null).then((detail) => {
                            this.detail = detail;
                            this.isLoaded = true;
                            this.showInstoreProduct = settings.content.productDetailStoreInfo ? (!isUndefined($stateParams.googleshop) && $stateParams.googleshop) : false;
                        });
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-product-detail ng-if="$ctrl.detail" detail="$ctrl.detail" is-loaded="$ctrl.isLoaded" show-instore-product="$ctrl.showInstoreProduct"></wow-product-detail>',
                },
                'rr-instrumentation-panel@root': {
                    controller: ['$stateParams', 'Settings', 'RichRelevanceService',
                        function ($stateParams, settings, richRelevanceService) {
                            this.removeDuplicatedProducts = settings.richRelevance.removeDuplicatedProducts;
                            this.productId = $stateParams.productId;
                            this.productName = $stateParams.productName;
                            this.placementIds = `${richRelevanceService.itemPageRankOne}, ${richRelevanceService.itemPageRankTwo}`;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-rr-item-instrumentation ng-if="!$ctrl.removeDuplicatedProducts" page-group="Category" item-id="$ctrl.productId" item-name="$ctrl.productName" placement-ids="$ctrl.placementIds"></wow-rr-item-instrumentation>',
                },
            },
        });

};



// WEBPACK FOOTER //
// ./src/configuration/routes/productdetail.js